export type OutsideBoundarySessionChoice = "pending" | "allow";
export type OutsideBoundaryWarningScope = "keypoint" | "bbox";

// Module scope deliberately survives viewer remounts while the page remains open.
// A refresh starts a fresh labeling session and asks again.
const outsideBoundarySessionChoices: Record<OutsideBoundaryWarningScope, OutsideBoundarySessionChoice> = {
  keypoint: "pending",
  bbox: "pending",
};

const OUTSIDE_BOUNDARY_SAVE_WARNING_ACKNOWLEDGED_KEY = "gleanag:outside-boundary-save-warning-acknowledged";
let outsideBoundarySaveWarningAcknowledgedFallback = false;

export const getOutsideBoundarySessionChoice = (scope: OutsideBoundaryWarningScope): OutsideBoundarySessionChoice =>
  outsideBoundarySessionChoices[scope];

export const setOutsideBoundarySessionChoice = (
  scope: OutsideBoundaryWarningScope,
  choice: OutsideBoundarySessionChoice
): void => {
  outsideBoundarySessionChoices[scope] = choice;
};

export const hasAcknowledgedOutsideBoundarySaveWarning = (): boolean => {
  try {
    return window.sessionStorage.getItem(OUTSIDE_BOUNDARY_SAVE_WARNING_ACKNOWLEDGED_KEY) === "true";
  } catch {
    return outsideBoundarySaveWarningAcknowledgedFallback;
  }
};

export const acknowledgeOutsideBoundarySaveWarning = (): void => {
  outsideBoundarySaveWarningAcknowledgedFallback = true;
  try {
    window.sessionStorage.setItem(OUTSIDE_BOUNDARY_SAVE_WARNING_ACKNOWLEDGED_KEY, "true");
  } catch {
    // The in-memory fallback still covers browsers that block sessionStorage.
  }
};
